import React, { useState } from 'react';

const STORAGE_KEY = 'homolog_auth_expires';
const DURATION_MS = 8 * 60 * 60 * 1000; // 8 horas
const HOMOLOG_KEY = 's6120908';

function isAuthenticated() {
  const expires = localStorage.getItem(STORAGE_KEY);
  if (!expires) return false;
  return Date.now() < parseInt(expires, 10);
}

export default function HomologGate({ children }) {
  const isHomolog = process.env.REACT_APP_IS_HOMOLOG === 'true';
  const [authed, setAuthed] = useState(() => !isHomolog || isAuthenticated());
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  if (!isHomolog || authed) {
    return children;
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === HOMOLOG_KEY) {
      localStorage.setItem(STORAGE_KEY, String(Date.now() + DURATION_MS));
      setAuthed(true);
    } else {
      setError('Senha incorreta.');
      setPassword('');
    }
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <span style={styles.badge}>HOMOLOGAÇÃO</span>
        <h2 style={styles.title}>Acesso Restrito</h2>
        <p style={styles.subtitle}>
          Ambiente de testes. Digite a senha para continuar.
        </p>
        <form onSubmit={handleSubmit}>
          <input
            type="password"
            value={password}
            onChange={(e) => { setPassword(e.target.value); setError(''); }}
            placeholder="Senha de acesso"
            style={styles.input}
            autoFocus
            autoComplete="off"
          />
          {error && <p style={styles.error}>{error}</p>}
          <button type="submit" style={styles.button}>
            Entrar
          </button>
        </form>
        <p style={styles.hint}>Acesso válido por 8 horas neste dispositivo.</p>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(15, 15, 30, 0.92)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    zIndex: 99999,
  },
  modal: {
    backgroundColor: '#ffffff', borderRadius: 14,
    padding: '40px 48px', maxWidth: 400, width: '90%',
    textAlign: 'center',
    boxShadow: '0 24px 64px rgba(0,0,0,0.5)',
  },
  badge: {
    display: 'inline-block', backgroundColor: '#f57c00', color: '#fff',
    padding: '4px 18px', borderRadius: 20, fontSize: 11, fontWeight: 700,
    letterSpacing: 2, marginBottom: 20,
  },
  title: { margin: '0 0 8px', fontSize: 22, color: '#1a1a2e', fontWeight: 700 },
  subtitle: { color: '#666', fontSize: 14, marginBottom: 24, lineHeight: 1.5 },
  input: {
    width: '100%', padding: '12px 16px', borderRadius: 8,
    border: '1.5px solid #ddd', fontSize: 16, marginBottom: 8,
    boxSizing: 'border-box', outline: 'none',
    transition: 'border-color 0.2s',
  },
  error: { color: '#e53935', fontSize: 13, margin: '0 0 10px' },
  button: {
    width: '100%', padding: '13px', backgroundColor: '#f57c00', color: '#fff',
    border: 'none', borderRadius: 8, fontSize: 16, fontWeight: 600,
    cursor: 'pointer', marginTop: 6,
    transition: 'background-color 0.2s',
  },
  hint: { color: '#bbb', fontSize: 12, marginTop: 18 },
};
